export const rechargeBelowOptions = [
  { name: '$5,000', id: 5000 },
  { name: '$2,500', id: 2500 },
  { name: '$1,000', id: 1000 },
  { name: '$500', id: 500 },
  { name: '$250', id: 250 },
  { name: '$100', id: 100 },
  { name: '$50', id: 50 },
  { name: '$25', id: 25 },
  { name: '$10', id: 10 }
];

export const rechargeAmountOptions = [
  { name: '$10,000', id: 10000 },
  { name: '$5,000', id: 5000 },
  { name: '$2,500', id: 2500 },
  { name: '$1,000', id: 1000 },
  { name: '$500', id: 500 },
  { name: '$250', id: 250 },
  { name: '$100', id: 100 },
  { name: '$50', id: 50 },
  { name: '$25', id: 25 }
];

export const cardTypes = [
  {
    type: 'visa',
    pattern: /^4/,
    luhn: true
  },
  {
    type: 'mastercard',
    pattern: /^5[1-5]/,
    luhn: true
  },
  {
    type: 'discover',
    pattern: /^(6011|65|64[4-9]|622)/,
    luhn: true
  },
  {
    type: 'amex',
    pattern: /^3[47]/,
    luhn: true
  },
  {
    type: 'maestro',
    pattern: /^(5018|5020|5038|6304|6759|676[1-3])/,
    luhn: true
  },
  {
    type: 'dinersclub',
    pattern: /^(36|38|30[0-5])/,
    luhn: true
  },
  {
    type: 'laser',
    pattern: /^(6706|6771|6709)/,
    luhn: true
  },
  {
    type: 'jcb',
    pattern: /^35/,
    luhn: true
  },
  {
    type: 'unionpay',
    pattern: /^62/,
    luhn: false
  }
];